import Icon from '../assets/DexScIcon.svg';

export function DexIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Icon} alt='Dex' />;
}
